import {Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';

import {AppService} from 'shared/services';
import {CustomizerSettingsService} from '../../customizer-settings/customizer-settings.service';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [RouterLink, MatButtonModule],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnInit {
  // isToggled
  isToggled = false;

  constructor(
    public themeService: CustomizerSettingsService,
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });

    // Cierra la sesion
    this.appService.logout();
  }
}
